<template>
  <div
    class="min-h-screen flex items-start justify-center pt-36 bg-body relative"
  >
    <div class="w-full max-w-md px-8 py-8">
      <h1 class="text-2xl font-extrabold text-center text-gray-800 mb-2">
        Reset Control Number
      </h1>
      <p class="text-center text-gray-500 mb-6">
        Please enter your
        <span class="font-medium text-gray-700">IWC Card Number</span>. Once
        verified, we’ll send it to your registered email address
      </p>

      <form @submit.prevent="handleSubmit">
        <div class="mb-6 relative">
          <input
            type="text"
            placeholder=" "
            v-model="iwccardno"
            class="peer w-full text-base font-medium bg-white text-gray-800 rounded-2xl px-4 pt-6 pb-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 shadow-sm focus:shadow-blue-300 transition duration-300"
            autocomplete="off"
            required
          />
          <label
            class="absolute left-4 top-2 text-gray-500 text-xs font-medium transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:text-xs peer-focus:top-2"
          >
            IWC Card Number
          </label>
        </div>

        <button
          type="submit"
          :disabled="loading"
          class="w-full py-3 bg-primary hover:bg-hover text-white font-semibold rounded-lg transition duration-200 flex items-center justify-center"
        >
          <span v-if="!loading">Reset Control Number</span>
          <span v-else>
            <svg
              class="animate-spin h-5 w-5 mr-2 text-white inline-block"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              ></path>
            </svg>
            Processing...
          </span>
        </button>

        <div
          v-if="validationAlert"
          class="mb-4 mt-6 flex items-center justify-center"
        >
          <div
            class="inline-block px-4 py-2 rounded-full bg-red-50 text-red-700 text-sm font-semibold shadow-sm border border-red-200"
          >
            {{ validationAlert }}
          </div>
        </div>
      </form>

      <div class="flex flex-col items-center mt-4">
        <div class="text-center text-sm text-gray-600">
          Back to Sign In
          <router-link to="/portal/login" class="text-blue-500 hover:underline">
            here
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, inject } from "vue";
import { useRouter } from "vue-router";

export default {
  setup() {
    const axios = inject("$axios");
    const Swal = inject("$swal");
    const iwccardno = ref("");
    const validationAlert = ref("");
    const loading = ref(false);
    const router = useRouter();

    const handleSubmit = async () => {
      loading.value = true;

      // Add 3-second delay before sending the request
      await new Promise((resolve) => setTimeout(resolve, 2000));

      try {
        const response = await axios.post("/api/patient/reset", {
          iwccardno: iwccardno.value,
        });

        if (response.data.status === 201) {
          Swal.fire({
            icon: "success",
            title: "📩 Check Your Email!",
            text: `Your Control Number has been sent to ${response.data.email}. Please check your email to proceed.`,
          }).then(() => router.push("/portal/login"));
        } else {
          validationAlert.value = response.data.message;

          // Clear alert after 6 seconds
          setTimeout(() => {
            validationAlert.value = "";
          }, 6000);
        }
      } catch (error) {
        alert("Something went wrong. Please try again.");
      } finally {
        loading.value = false;
      }
    };

    return {
      iwccardno,
      loading,
      validationAlert,
      handleSubmit,
    };
  },
};
</script>
